<template>
  <div class="form-section mb-0">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Nivel educativo</label>
          <FormSelect
            id="educationLevel"
            v-model="form.educationLevel"
            :items="educationLevelList"
            defaultOption="Elegir nivel"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Profesión</label>
          <input
            type="text"
            v-model="form.profession"
            autocomplete="off"
            placeholder="Ingresar profesión"
            class="custom-form-control"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormSelect } from 'wize-admin'
import { Constants } from '@/core/utils'

export default {
  components: { FormSelect },
  props: {
    form: { type: Object, required: true },
    v:    { type: Object, required: true },
  },
  data() {
    return {
      educationLevelList: Object.values(Constants.EducationLevel),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
